export function initThreeStateCheckbox (container) {
	$(container).find('.checkbox-bool[data-empty-value=true]').click(function () {
		initDataInBoolean($(this).attr('id'), getNextChecboxState($(this).attr('data-value')))
	})
}

function getNextChecboxState (currentState) {
	switch (currentState) {
		case 'false':
			return 'true'
		case 'true':
			return 'null'
		case 'null':
			return 'false'
	}
}
